import { useMemo } from 'react';

import { buildAllFormValues } from 'helpers/candidate_application/form-page-helpers';
import { useSelector } from 'react-redux';

import { selectCandidateApplication } from 'api/candidate-application-slice';

export default function useAllFormValues({ watchValues, currentPagePrefixes } = {}) {
  const { candidateFields } = useSelector(selectCandidateApplication);

  return useMemo(
    () =>
      buildAllFormValues({
        candidateFields,
        watchValues,
        currentPagePrefixes,
      }),
    [
      candidateFields?.candidateValues,
      candidateFields?.hiddenValues,
      candidateFields?.formValues,
      candidateFields?.idRequirementsMet,
      watchValues,
      currentPagePrefixes,
    ],
  );
}
